export const randomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}



// validators 

export const isNumber = (value) => {
  // return Math.round(value) === value;
  return /^-?\d*$/.test(value)
}

export const isPositiveNumber = (value) => {
  console.log('isPositiveNumber',value)
  return /^\+?[1-9]\d*$/.test(value)
  // return /^\d*$/.test(value)
}

// two decimals
export const isCurrency = (value) => {
  // return /^-?\d*[.,]?\d{0,2}$/.test(value)
  return /^([1-9][0-9]{0,1})-?\d*[.,]?\d{0,2}$/.test(value)
}

// allows both . and , as decimal separator
export const isFloat = (value) => {
  /^-?\d*[.,]?\d*$/.test(value)
}

export const formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? "-" : ""

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    let j = (i.length > 3) ? i.length % 3 : 0

    let rawValue = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "")

    // if (rawValue.indexOf('.00') > -1) {
    //   rawValue = rawValue.replace('.00', '')
    // }

    return rawValue

  } catch (e) {
    console.log(e)
  }
}

export default {
  randomInt,
  isNumber,
  isPositiveNumber,
  isCurrency,
  isFloat,
  formatMoney,
};